import React, { useState } from "react";
import { RESUME_TIPS } from "../../utils/constants";
import { InfoIcon } from "../Icons/Icons";
import Popup from "../Popup/Popup";
import styles from "./ResumeTips.module.css";

function ResumeTips({ section, className }) {
  const [showPopup, togglePopup] = useState(false);

  const tips = RESUME_TIPS[section];
  return (
    <div className={`${styles.resumeTip} ${className}`}>
      <InfoIcon
        className={styles.trigger}
        onClick={() => togglePopup((show) => !show)}
      />
      {showPopup && (
        <Popup className={styles.popup} onClose={() => togglePopup(false)}>
          <ul>
            {tips?.map((tip, key) => (
              <li key={key}>{tip}</li>
            ))}
          </ul>
        </Popup>
      )}
    </div>
  );
}

export default ResumeTips;
